import { authClient } from "./authClient";

// Fetch the session information when loading the page without blocking rendering
authClient.getSession();

export const checkSession = async (): Promise<boolean> => {
	// Only check once every 60 seconds
	const lastSessionCheck = localStorage.getItem("last-session-check");
	if (lastSessionCheck && Date.now() - parseInt(lastSessionCheck) < 1000 * 60) {
		return Boolean(localStorage.getItem("better-auth-jwt"));
	}

	const session = await authClient.getSession().catch(() => {
		throw new Error("Authentication server down");
	});

	localStorage.setItem("last-session-check", Date.now().toString());
	return Boolean(session.data);
};
